import {useSyncExternalStore} from 'react';

import {dragStore, selectActiveId} from '../store/dragStore';

export const useActiveId = () => useSyncExternalStore(dragStore.subscribe, selectActiveId);
